module.exports = __webpack_public_path__ + "media/images/stallion-4a90a332197ae6b29bd2494fb01bc19f.jpg";